/* eslint-disable */

//tslint:disable

import { IHttpApi, IHttpApiFetchConfig } from "@cian/http-api/shared/http";
import {
  TApplyForPublicationModel,
  IApplyForPublicationRequest,
  IMappers,
  IApplyForPublicationResponse,
  IApplyForPublicationResponseError,
  TApplyForPublicationResponse
} from "./types";

const defaultConfig: TApplyForPublicationModel = {
  apiType: "public",
  assertStatusCodes: [200, 400],
  method: "POST",
  microserviceName: "coworking",
  pathApi: "/v1/apply-for-publication/",
  hostType: "ud-api"
} as TApplyForPublicationModel;

function createApplyForPublicationModel(
  parameters: IApplyForPublicationRequest
): TApplyForPublicationModel {
  return {
    ...defaultConfig,
    parameters
  };
}

export interface IApplyForPublicationOptions<TResponse200, TResponse400> {
  httpApi: IHttpApi;
  parameters: IApplyForPublicationRequest;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200, TResponse400>;
}

async function fetchApplyForPublication<TResponse200, TResponse400>({
  httpApi,
  parameters,
  config,
  mappers
}: IApplyForPublicationOptions<TResponse200, TResponse400>): Promise<
  TResponse200 | TResponse400 | TApplyForPublicationResponse
> {
  const { response, statusCode } = await httpApi.fetch(
    createApplyForPublicationModel(parameters),
    config
  );

  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as IApplyForPublicationResponse);
    }

    if (statusCode === 400) {
      return mappers[400](response as IApplyForPublicationResponseError);
    }
  }

  return { response, statusCode } as TApplyForPublicationResponse;
}

export {
  defaultConfig,
  createApplyForPublicationModel,
  fetchApplyForPublication
};
